import HeadlineField from '@/components/customFields/HeadlineField';
import { HeadlineTag } from '@/components/customFields/types';
import { convertToHeadlineTag } from '@/components/customFields/utils';
import EightColumnLayout from '@/components/eightColumnLayout/EightColumnLayout';
import type { ComponentIframeStoryblok } from '@/types/component-types-sb';
import { Size } from '@/types/image';
import { Breakpoint } from '@/types/layoutTypes';

import classes from './Iframe.module.scss';

const Iframe: React.FC<{ blok: ComponentIframeStoryblok }> = ({ blok }) => {
  return (
    <EightColumnLayout
      anchorId={blok.anchorId}
      applyLayout={blok.width === Size.MEDIUM}
      breakpoint={Breakpoint.DESKTOP_MAX}
    >
      <div>
        <HeadlineField tag={convertToHeadlineTag(blok.headlineTag, HeadlineTag.H2)} style={HeadlineTag.H3}>
          {blok.headlineText}
        </HeadlineField>
        <iframe src={blok.url} title={blok.title} height={blok.height} className={classes.iframe} />
      </div>
    </EightColumnLayout>
  );
};

export default Iframe;
